// pages/OfflinePage.js
import React from "react";

const OfflinePage = ({onRetry}) => {
  return (
    <div className="fixed dark inset-0 bg-cblack bg-opacity-95 flex justify-center items-center z-50 animate-fadeIn">
      <div className="bg-cblack5 p-8 md:p-12 rounded-2xl shadow-2xl border flex flex-col items-center max-w-md w-full text-center">
        <div className="text-red-600 text-6xl mb-6 animate-bounce">⚠️</div>
        <h1 className="text-3xl md:text-4xl font-bold text-gray-300 mb-4">
          You are Offline
        </h1>
        <p className="text-gray-400 mb-8 text-lg">
          It seems your internet connection is lost. Please check your network
          and try again.
        </p>
        <button
          onClick={onRetry}
          className="px-8 py-3 bg-blue-600 hover:bg-blue-700 text-white font-semibold rounded-xl shadow-lg transition transform hover:scale-105"
        >
          Retry
        </button>
      </div>
    </div>
  );
};

export default OfflinePage;
